import React from "react";

import { t } from "app/utils";

import QueryStringSwitch, { QueryStringSwitchState } from "components/filters/QueryStringSwitch";

const queryKey = "m";
const options = {
  host: t("Hosted"),
  responded: t("Responded"),
  invited: t("Invited")
};

const UserRelationFilter = () => (
  <QueryStringSwitch
    clearLabel={t("All Events")}
    options={options}
    queryKey={queryKey}
    title={t("My Events")}
  />
);

export const UserRelationFilterState = () => (
  <QueryStringSwitchState options={options} queryKey={queryKey} />
);

export default UserRelationFilter;
